import { useDispatch } from 'react-redux';

const useCustomDispatch = () => {
  const dispatch = useDispatch();

  const customeDispatchFunction = (payload) => {
    dispatch(payload);
  };

  return { customeDispatchFunction };
};

export default useCustomDispatch;
